if (!customElements.get('frame-option-selector-modal')) {
  class FrameOptionSelectorModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.backdrop = this.querySelector('.size-modal__backdrop');
      this.optionsContainer = this.querySelector('[data-frame-options]');
      this.loadingEl = this.querySelector('[data-frame-loading]');
      this.querySelector('[data-close]')?.addEventListener('click', () => this.close());
      this.backdrop?.addEventListener('click', () => this.close());
      this.dialog?.addEventListener('keydown', (e) => { if (e.key === 'Escape') { e.preventDefault(); this.close(); } });
    }
    async open(productHandle, lineKey, properties) {
      this.lineKey = lineKey; this.properties = properties;
      this.loadingEl.style.display = 'block'; this.optionsContainer.style.display = 'none';
      this.dialog?.showModal(); this.backdrop?.classList.add('active'); document.body.style.overflow = 'hidden';
      try {
        const res = await fetch('/products/' + productHandle + '.json');
        const data = await res.json();
        this.renderOptions(data.product);
      } catch(e) { console.error('Failed to load frame options:', e); }
    }
    renderOptions(product) {
      this.loadingEl.style.display = 'none'; this.optionsContainer.style.display = 'grid'; this.optionsContainer.innerHTML = '';
      product.variants.filter(v => v.available).forEach(variant => {
        const btn = document.createElement('button');
        btn.className = 'size-modal__size-btn'; btn.textContent = variant.title;
        btn.addEventListener('click', () => { this.close(); window.performUpsell(this.lineKey, variant.id, this.properties); });
        this.optionsContainer.appendChild(btn);
      });
    }
    close() { this.dialog?.close(); this.backdrop?.classList.remove('active'); document.body.style.overflow = ''; }
  }
  customElements.define('frame-option-selector-modal', FrameOptionSelectorModal);
}
